export const SelectButtonDT = {
	selectbutton: {
		extend: {
			text: {
				on: '',
				of: '',
			},
		},
		css: ({ dt }) => `
              .p-selectbutton .p-togglebutton {
                  padding: .25rem 1rem;
              }
              .p-selectbutton-normalize {
                  .p-togglebutton:disabled {
                      opacity: .7;
                  }
                  .p-togglebutton.p-togglebutton-checked {
                      background: var(--p-togglebutton-checked-background);
                      border-color: var(--p-togglebutton-checked-border-color);
                      color: var(--p-togglebutton-checked-color);
                  }
              }
              .p-select-button-like-normal {
                  gap: 10px;
              }
              .p-select-button-like-normal-child {
                  .p-togglebutton {
                      border-radius: 0;
                      background:  ${dt('selectbutton.text.off.color')};
                  }
                  .p-togglebutton:first-child {
                      border-color: transparent;
                      border-radius: var(--p-selectbutton-border-radius);
                  }
                  .p-togglebutton.p-togglebutton-checked {
                      background:  ${dt('selectbutton.text.on.color')};
                  }
              }
        `,
		colorScheme: {
			light: {
				text: {
					on: { color: '#F2F2F2' },
					off: { color: '#FAFAFA' },
				},
			},
			dark: {
				text: {
					on: { color: '#3f3f46' },
					off: { color: '#18181b' },
				},
			},
		},
	},
};
